import { useTranslation } from "react-i18next";
import { Image } from "lucide-react";

/**
 * Empty state component for media attachments
 * Displays a message when no media attachments are found
 */
export default function MediaAttachmentEmpty() {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 p-4">
      <Image className="size-8 text-muted-foreground" />
      <p className="text-sm text-muted-foreground">
        {t("chatDetailsTabs.no_media")}
      </p>
    </div>
  );
}
